<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;line-height: 36px;">
                <!-- <el-button size="mini" :class="form.isInvoiced ==0 ?'selected':''" @click="titleClick(0)">未开票</el-button>
                <el-button size="mini" style="margin-left: 25px;" @click="titleClick(1)" :class="form.isInvoiced ==1 ?'selected':''">已开票</el-button> -->
                <el-button size="mini" :disabled="listLoading" :class="form.workOrderType == 0 ? 'selected' : ''"
                    @click="titleClick(0)">全部</el-button>
                <el-button size="mini" :disabled="listLoading" style="margin-left: 25px;"
                    :class="form.workOrderType == 1 && !isCredit ? 'selected' : ''"
                    @click="titleClick(1)">已完成</el-button>
                <el-button size="mini" :disabled="listLoading" style="margin-left: 25px;" :class="form.workOrderType == 2 ? 'selected' : ''"
                    @click="titleClick(2)">未完成</el-button>
                <el-button size="mini" :disabled="listLoading" style="margin-left: 25px;"
                    :class="form.workOrderType == 1 && isCredit ? 'selected' : ''"
                    @click="creditClick()" title="2025-04-01后完成的单子">额度应收</el-button>
  
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" plain @click="openInvoice()">批量开票</el-button>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                <el-button size="medium" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table ref="tableData" :stripe="true" :data="tableData" style="width: 100%" height="666" border
            @selection-change="handleSelectionChange" v-loading="listLoading">
            <!-- eslint-disable  -->
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="订单号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.orderNo" placeholder="输入关键字搜索"
                            @keyup.enter.native="GetCouponsList()" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.orderNo || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="订单名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.orderName" placeholder="输入关键字搜索"
                            @keyup.enter.native="GetCouponsList()" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.orderName || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="平台">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.orderSource" placeholder="输入关键字搜索"
                            @keyup.enter.native="GetCouponsList()" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.orderSourceStr || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单方">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.senderName" placeholder="输入关键字搜索"
                            @keyup.enter.native="GetCouponsList()" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.senderName || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单方角色">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.rolesName" placeholder="输入关键字搜索"
                            @keyup.enter.native="GetCouponsList()" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.rolesName || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单Code">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.senderCode" placeholder="输入关键字搜索"
                            @keyup.enter.native="GetCouponsList()" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.senderCode || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="应收金额">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.senderMoneyBegin" style="width: 45%;" placeholder="搜索"
                            type="number" /> ~
                        <el-input size="mini" v-model="form.senderMoneyEnd" style="width: 45%;" placeholder="搜索"
                            @keyup.enter.native="GetCouponsList()" type="number" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.senderMoney }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="款项支付时间">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker size="mini" v-model="form.paySuccess" type="daterange" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始日期"
                            :disabled="datePickerReadonly" end-placeholder="结束日期" style="width: 100%;"
                            @change="GetCouponsList()"></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.paySuccessDate }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="备注">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.remark" placeholder="请选择款项名称" style="width: 100%;"
                            @change="GetCouponsList()">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.key" :label="item.value"
                                v-for="(item, index) in payMentNameOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.remark || '--' }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <p style="margin-bottom: -42px;font-size: 14px;line-height: 32px;">已选中 {{ num }} 条信息</p>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="form.PageNo" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <MakeInvoice ref="makeInvoice" />
    </div>
</template>

<script>
import MakeInvoice from './index/makeInvoice'
// DOTO：静态展示数据 对接的时候可以删掉
import { PERIOD } from '@/config/const/common.js'
// End
import {
    getStorageToken, getStorageUserRoleId
} from '@/utils/store'
import {
    receivableList, batchInvoiceEcho, payMentNameOption,
} from "@/service/payApi";
import couponsIssueVue from '../coupons/couponsIssue.vue';
export default {
    components: {
        MakeInvoice
    },
    data() {
        return {
            PERIOD,
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,
                Name: '',               //名称
                orderName: '',
                orderNo: '',
                orderSource: '',
                remark: '',
                rolesName: '',
                senderCode: '',
                senderMoneyBegin: '',
                senderMoneyEnd: '',
                senderName: '',

                paySuccess: [],             //支付时间数组
                workOrderType: 0,           //工单类型 
            },
            isCredit: false,//是否是额度营收
            datePickerReadonly: false,
            searchData: {},
            oraginForm: {},
            total: 0,                       //总条数
            tableData: [],
            num: 0,                         //选中的数量
            orderIds: [],
            noteIds: [],
            senderCode: [],
            selected_items: {},
            payMentNameOptionArr: [],
        }
    },
    activated() {
        this.handleSearch()
        this.getPayMentNameOption()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        titleClick(type) {

            if (this.listLoading) 
            {
                return this.$message.error('请等待加载');
            }
            this.form.workOrderType = type;
            this.form.PageNo = 1;
            this.form.PageSize = 10
            this.isCredit = false;
            this.datePickerReadonly = false;
            this.form.paySuccess = [];
            this.handleSearch()
        },
        //额度应收
        creditClick() {
            if (this.listLoading) 
            {
                return this.$message.error('请等待加载');
            }
            this.form.workOrderType = 1;
            this.isCredit = true;
            this.form.PageNo = 1;
            this.form.PageSize = 10
            this.datePickerReadonly = true;

            const now = new Date();
            var year = now.getFullYear();
            var month = now.getMonth() + 1;
            var day = now.getDate();
            var end = year + '-' + month + '-' + day;
            console.log("end:" + end);
            console.log("datePickerReadonly:" + this.datePickerReadonly);

            this.form.paySuccess = ['2025-04-01', end];
            this.handleSearch()
        },
         
        getPayMentNameOption() {
            payMentNameOption().then((r) => {
                if (r.Result != 1) {
                    return this.$message.error(r.Message)
                }
                this.payMentNameOptionArr = r.Data
            })
        },
        downloadFile() {
            const _this = this;
            let data = {}
            if (_this.form.paySuccess instanceof Array && _this.form.paySuccess.length > 0) {
                data.paySuccessDateBegin = _this.form.paySuccess[0] + " 00:00:00";
                data.paySuccessDateEnd = _this.form.paySuccess[1] + " 23:59:59";
            } else {
                delete data.paySuccess;
            }
            if (this.form.orderName) data.orderName = this.form.orderName
            if (this.form.orderNo) data.orderNo = this.form.orderNo
            if (this.form.orderSource) data.orderSource = this.form.orderSource
            if (this.form.remark) data.remark = this.form.remark
            if (this.form.rolesName) data.rolesName = this.form.rolesName
            if (this.form.senderCode) data.senderCode = this.form.senderCode
            if (this.form.senderMoneyBegin) data.senderMoneyBegin = this.form.senderMoneyBegin
            if (this.form.senderMoneyEnd) data.senderMoneyEnd = this.form.senderMoneyEnd
            if (this.form.senderName) data.senderName = this.form.senderName
            data.workOrderType = this.form.workOrderType
            let url =
                process.env.NODE_ENV == "development" ?
                    "/api2" :
                    process.env.VUE_APP_API2;

            window.open(
                url + "/gz/admin/download/receivable/download" + "?" + this.parseJsonURL(data)
            );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
                Object.keys(json).map(function (key) {
                    if (json[key] === undefined) return "";
                    return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
                })
            ).join("&");
        },
        cleanArray(actual) {
            var newArray = [];
            for (var i = 0; i < actual.length; i++) {
                if (actual[i]) {
                    newArray.push(actual[i]);
                }
            }
            return newArray;
        },
        //渲染列表
        handleSearch() {
            if (this.listLoading) return
            this.searchData = Object.assign({}, this.form)
            this.GetCouponsList()
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetCouponsList()
        },
        //翻页
        handleSizeChange(val) {
            if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetCouponsList()
        },
        // TODO：修改接口名 form参数 table展示数据
        async GetCouponsList() {
            const _this = this;

            this.listLoading = true;
 
            // let data = JSON.parse(JSON.stringify(this.searchData))
            let data = {
                pageNum: this.form.PageNo,
                pageSize: this.form.PageSize,
                rational: true,
            }
            // !data.Name && delete data.Name
            data.Token = getStorageToken();
            data.platform = 'zyd'
            if (_this.form.paySuccess instanceof Array && _this.form.paySuccess.length > 0) {
                data.paySuccessDateBegin = _this.form.paySuccess[0] + " 00:00:00";
                data.paySuccessDateEnd = _this.form.paySuccess[1] + " 23:59:59";
            } else {
                delete data.paySuccess;
            } 

            console.log('paySuccessDateBegin:' + data.paySuccessDateBegin);
            console.log('paySuccessDateEnd:' + data.paySuccessDateEnd);

            if (this.form.orderName) data.orderName = this.form.orderName
            if (this.form.orderNo) data.orderNo = this.form.orderNo
            if (this.form.orderSource) data.orderSource = this.form.orderSource
            if (this.form.remark) data.remark = this.form.remark
            if (this.form.rolesName) data.rolesName = this.form.rolesName
            if (this.form.senderCode) data.senderCode = this.form.senderCode
            if (this.form.senderMoneyBegin) data.senderMoneyBegin = this.form.senderMoneyBegin
            if (this.form.senderMoneyEnd) data.senderMoneyEnd = this.form.senderMoneyEnd
            if (this.form.senderName) data.senderName = this.form.senderName
            data.workOrderType = this.form.workOrderType
            let res = await receivableList(data)
            this.listLoading = false;
   
            if (res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }

            // debugger

            const old = JSON.parse(JSON.stringify(this.selected_items));
            this.selected_items = {};

            this.tableData = res.Data.datas;
            this.total = res.Data.total;
            // console.log('tableData:'+JSON.stringify(tableData));
            this.num = Object.keys(old).length;
            this.$forceUpdate();

            if (Object.keys(old).length)
                this.$nextTick(() => {
                    for (var idx1 in _this.tableData) {
                        const item1 = _this.tableData[idx1];
                        if (old[item1.onId]) {
                            _this.$refs.tableData.toggleRowSelection(item1);
                        }
                    }

                    for (var key1 in old) {
                        const item2 = old[key1];
                        _this.selected_items[key1] = item2;
                    }

                    _this.num = Object.keys(_this.selected_items).length;
                    _this.$forceUpdate();
                });
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()

            this.selected_items = {};
            this.$forceUpdate();

        },
        // table选中
        handleSelectionChange(val) {
            // this.selected_items = {};

            for (var idx in this.tableData) {
                const item = this.tableData[idx];
                if (this.selected_items[item.onId]) delete this.selected_items[item.onId];
            }

            for (var idxs in val) {
                const item2 = val[idxs];
                this.selected_items[item2.onId] = item2;
            }

            // debugger
            // console.table(val)
            this.num = Object.keys(this.selected_items).length;
        },

        // 点击批量开票
        openInvoice() {
            this.listLoading = true;
            this.orderIds = [];
            this.noteIds = [];
            this.senderCode = [];
            for (var key in this.selected_items) {
                const item = this.selected_items[key];
                this.orderIds.push(item.orderId);
                this.noteIds.push(item.noteId);
                this.senderCode.push(item.senderCode);
            }


            var temp1 = []
            temp1 = Array.from(new Set(this.senderCode))


            if (temp1.length > 1) {
                this.listLoading = false;
                return this.$message.error('只能选择同一客户进行开票')
            }

            if (this.orderIds.length <= 0) {
                this.listLoading = false;
                return this.$message.error('请先选择')
            }



            var data = {
                manageUserId: getStorageUserRoleId(),
                OrderIds: this.orderIds,
                NoteIds: this.noteIds,
                // platform : 'zyd',
                UserCode: temp1[0],
            }
            batchInvoiceEcho(data).then((r) => {
                this.listLoading = false;
                if (r.Result != 1) {
                    return this.$message.error(r.Message)
                }
                this.$refs.makeInvoice.open(this.orderIds, this.senderCode, r.Data.Invoice, this.noteIds, 0)
            })

        },

    }
}
</script>

<style lang="scss">
.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.row-bg {
    padding: 10px 14px;
    background-color: #f9fafc;
}

.section-box {
    .selected {
        color: #409EFF;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
    }
}
</style>